import { Api } from 'models/services/api';
import { DeleteOriginalDishCategoryQuery } from 'models/services/graphql';

import { OriginalDishCategoryData } from '../index';

type DataToDelete = {
  id: string;
};

const RequestQuery = `
  mutation DeleteOriginalDishCategory($id: ID!) {
    ${DeleteOriginalDishCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    deleteOriginalDishCategory: OriginalDishCategoryData
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: OriginalDishCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToDelete): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw 'invalid response';
    const document = api.response.data.deleteOriginalDishCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };